import { Form, Input, Modal, ModalProps, Select } from "antd"
import { createRoot } from "react-dom/client"
import { PropertySetModule } from "@/services/admin/property-set/modal"
import { reactionTypeToOption } from "@/common/dict"
import { useEffect } from "react"
import { ReactionPartnersEditor } from "./ReactionPartnersEditor"
import { createPropertySetReactions, updatePropertySetReactions } from "@/services/admin/property-set"

interface AddEditReactionProps extends ModalProps {
  onSuccess?: () => void
  reaction?: PropertySetModule.Reaction
  propertySet: PropertySetModule.Modal
}

export function AddEditReaction(props: AddEditReactionProps)  {
  const { reaction, onSuccess, onCancel, propertySet } = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (reaction) {
      form.setFieldsValue(reaction)
    }
  })

  const handleCancel = (e?) => {
    onCancel?.(e)
    form.resetFields()
  }

  const save = async (values) => {
    if (!reaction) {
      await createPropertySetReactions(values, { setId: propertySet.id })
    } else {
      await updatePropertySetReactions(values, { setId: propertySet.id, id: reaction.id })
    }
    onSuccess?.()
  }

  if (!propertySet) return null

  return <Modal
    {...props}
    width={900}
    open={true}
    maskClosable={false}
    onCancel={handleCancel}
    onOk={() => form.submit()}
  >
    <div>Add Reaction</div>
    <Form
      form={form}
      onFinish={(values) => {
        save(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter reaction name' }]}>
        <Input type='text' style={{width: 300}} />
      </Form.Item>

      <Form.Item label='Type' name='type' rules={[{ required: true, message: 'Please selected a reaction type' }]}>
        <Select options={reactionTypeToOption()} style={{width: 300}} />
      </Form.Item>

      <Form.Item label='Reaction Partners' name='reactants'>
        <ReactionPartnersEditor propertySet={propertySet} />
      </Form.Item>
      
    </Form>
  </Modal>
}

AddEditReaction.show = (props: AddEditReactionProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<AddEditReaction
    {...props}
    onSuccess={() => {
      props.onSuccess?.()
      root.unmount()
    }}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
  />);
}